import { useAuth } from '@rs-core/context/UserAuthContext';
import useTwilioLock from '@rs-core/hooks/useTwilioLock';
import useGetSearchParams from '@rs-core/hooks/useGetSearchParams';
import { useBooleanFlagValue } from '@rs-core/hooks/useFlags';

const useReportAccessIndicator = () => {
	const galaxyDvReportAccessIndicator = useBooleanFlagValue('galaxy-dv-report-access-indicator');

	if (!galaxyDvReportAccessIndicator) {
		return {
			isLocked: false,
			lockHolder: null,
			lockHolderId: null,
			canEdit: true,
			acquireLock: () => {},
			releaseLock: () => {},
			updateDocumentId: () => {},
		};
	}
	const { loggedInUser } = useAuth();
	const { studyId } = useGetSearchParams();
	const browserFingerPrint = localStorage.getItem('browserFingerPrint');
	const {
		isLocked,
		lockHolder,
		lockHolderId,
		canEdit,
		acquireLock: acquireLockTwilio,
		releaseLock,
		documentId,
		updateDocumentId: updateDocumentIdTwilio,
	} = useTwilioLock({
		key: `DocumentViewer_${studyId}`,
		id: browserFingerPrint,
	});
	const acquireLock = async startDocumentId => acquireLockTwilio(loggedInUser, browserFingerPrint, startDocumentId);
	const updateDocumentId = async newDocumentId => updateDocumentIdTwilio(browserFingerPrint, newDocumentId);

	return { isLocked, lockHolder, lockHolderId, canEdit, acquireLock, releaseLock, documentId, updateDocumentId };
};

export default useReportAccessIndicator;
